var map = {
	"./article.js": 1001,
	"./auth.js": 4569,
	"./file.js": 217,
	"./job.js": 572,
	"./payroll.js": 7196,
	"./staff.js": 4887,
	"./talent.js": 8646,
	"./user.js": 7085,
	"./wechat.js": 286,
	"./work_order.js": 4854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5855;